import React, { useState } from 'react';
import { useOrganization } from '../contexts/OrganizationContext';
import { useAuth } from '../contexts/AuthContext';
import { PlusIcon, CheckCircleIcon, ExternalLinkIcon, TrashIcon, EditIcon } from 'lucide-react';
export function Integrations() {
  const {
    language
  } = useOrganization();
  const {
    isAdmin
  } = useAuth();
  const [showAddModal, setShowAddModal] = useState(false);
  const t = {
    title: language === 'en' ? 'Integrations' : 'Інтеграції',
    subtitle: language === 'en' ? 'Manage Knowledge Spaces connections and webhooks' : 'Керування підключеннями Knowledge Spaces та вебхуками',
    chatbots: language === 'en' ? 'Knowledge Spaces Chatbots' : 'Чатботи Knowledge Spaces',
    addChatbot: language === 'en' ? 'Add Chatbot' : 'Додати чатбот',
    active: language === 'en' ? 'Active' : 'Активний',
    edit: language === 'en' ? 'Edit' : 'Редагувати',
    delete: language === 'en' ? 'Delete' : 'Видалити',
    viewInSpaces: language === 'en' ? 'View in Spaces' : 'Переглянути в Spaces',
    webhookLogs: language === 'en' ? 'Webhook Logs' : 'Журнали вебхуків',
    exerciseCompleted: language === 'en' ? 'Exercise completed' : 'Вправу завершено',
    viewAllLogs: language === 'en' ? 'View All Logs' : 'Переглянути всі журнали',
    autoDelivery: language === 'en' ? 'Results are automatically delivered to configured chatbots. Each chatbot must have a valid Spaces Chatbot ID.' : 'Результати автоматично доставляються до налаштованих чатботів. Кожен чатбот повинен мати дійсний ID чатбота Spaces.',
    addNewChatbot: language === 'en' ? 'Add New Chatbot' : 'Додати новий чатбот',
    chatbotName: language === 'en' ? 'Chatbot Name' : 'Назва чатбота',
    chatbotId: language === 'en' ? 'Spaces Chatbot ID' : 'ID чатбота Spaces',
    orgId: language === 'en' ? 'Spaces Organization ID' : 'ID організації Spaces',
    cancel: language === 'en' ? 'Cancel' : 'Скасувати',
    save: language === 'en' ? 'Save Chatbot' : 'Зберегти чатбот'
  };
  return <div className="p-8" data-id="element-1556">
      <div className="mb-8" data-id="element-1557">
        <h1 className="text-3xl font-semibold text-gray-900" data-id="element-1558">{t.title}</h1>
        <p className="text-gray-600 mt-1" data-id="element-1559">{t.subtitle}</p>
        {!isAdmin && <div className="mt-2 inline-flex items-center gap-2 px-3 py-1 bg-yellow-50 border border-yellow-200 rounded-lg" data-id="element-1560">
            <span className="text-xs font-medium text-yellow-800" data-id="element-1561">
              Read-Only Access
            </span>
          </div>}
      </div>
      <div className="max-w-4xl space-y-6" data-id="element-1562">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-1563">
          <div className="flex items-center justify-between mb-4" data-id="element-1564">
            <h2 className="text-lg font-semibold text-gray-900" data-id="element-1565">
              {t.chatbots}
            </h2>
            {isAdmin && <button onClick={() => setShowAddModal(true)} className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2 text-sm" data-id="element-1566">
                <PlusIcon className="w-4 h-4" data-id="element-1567" />
                {t.addChatbot}
              </button>}
          </div>
          <div className="space-y-3" data-id="element-1568">
            <div className="p-4 border border-gray-200 rounded-lg hover:border-blue-300 transition-colors" data-id="element-1569">
              <div className="flex items-start justify-between mb-2" data-id="element-1570">
                <div data-id="element-1571">
                  <div className="font-medium text-gray-900" data-id="element-1572">
                    Dr. Bill Ukrainian Support
                  </div>
                  <div className="text-sm text-gray-600 mt-1" data-id="element-1573">
                    KS-BOT-DRBILL-UK-01
                  </div>
                </div>
                <CheckCircleIcon className="w-5 h-5 text-green-500" data-id="element-1574" />
              </div>
              <div className="flex items-center gap-2 text-xs text-gray-500" data-id="element-1575">
                <span data-id="element-1576">Org: KS-ORG-HEARST-001</span>
                <span data-id="element-1577">•</span>
                <span data-id="element-1578">{t.active}</span>
              </div>
              {isAdmin && <div className="mt-3 flex gap-2" data-id="element-1579">
                  <button className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 transition-colors flex items-center gap-1" data-id="element-1580">
                    <EditIcon className="w-3 h-3" data-id="element-1581" />
                    {t.edit}
                  </button>
                  <button className="px-3 py-1 text-sm text-red-600 border border-red-300 rounded hover:bg-red-50 transition-colors flex items-center gap-1" data-id="element-1582">
                    <TrashIcon className="w-3 h-3" data-id="element-1583" />
                    {t.delete}
                  </button>
                  <a href="#" className="px-3 py-1 text-sm text-blue-600 hover:text-blue-800 flex items-center gap-1" data-id="element-1584">
                    <ExternalLinkIcon className="w-3 h-3" data-id="element-1585" />
                    {t.viewInSpaces}
                  </a>
                </div>}
            </div>
            <div className="p-4 border border-gray-200 rounded-lg hover:border-blue-300 transition-colors" data-id="element-1586">
              <div className="flex items-start justify-between mb-2" data-id="element-1587">
                <div data-id="element-1588">
                  <div className="font-medium text-gray-900" data-id="element-1589">
                    Mental Health Coach EN
                  </div>
                  <div className="text-sm text-gray-600 mt-1" data-id="element-1590">
                    KS-BOT-COACH-EN-02
                  </div>
                </div>
                <CheckCircleIcon className="w-5 h-5 text-green-500" data-id="element-1591" />
              </div>
              <div className="flex items-center gap-2 text-xs text-gray-500" data-id="element-1592">
                <span data-id="element-1593">Org: KS-ORG-HEARST-001</span>
                <span data-id="element-1594">•</span>
                <span data-id="element-1595">{t.active}</span>
              </div>
              {isAdmin && <div className="mt-3 flex gap-2" data-id="element-1596">
                  <button className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-50 transition-colors flex items-center gap-1" data-id="element-1597">
                    <EditIcon className="w-3 h-3" data-id="element-1598" />
                    {t.edit}
                  </button>
                  <button className="px-3 py-1 text-sm text-red-600 border border-red-300 rounded hover:bg-red-50 transition-colors flex items-center gap-1" data-id="element-1599">
                    <TrashIcon className="w-3 h-3" data-id="element-1600" />
                    {t.delete}
                  </button>
                  <a href="#" className="px-3 py-1 text-sm text-blue-600 hover:text-blue-800 flex items-center gap-1" data-id="element-1601">
                    <ExternalLinkIcon className="w-3 h-3" data-id="element-1602" />
                    {t.viewInSpaces}
                  </a>
                </div>}
            </div>
          </div>
        </div>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-1603">
          <h2 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1604">
            {t.webhookLogs}
          </h2>
          <div className="space-y-2" data-id="element-1605">
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded text-sm" data-id="element-1606">
              <div className="flex items-center gap-3" data-id="element-1607">
                <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-1608"></div>
                <span className="text-gray-900" data-id="element-1609">{t.exerciseCompleted}</span>
                <span className="text-gray-500" data-id="element-1610">EXT-UKR-000123</span>
              </div>
              <span className="text-gray-500" data-id="element-1611">2 hours ago</span>
            </div>
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded text-sm" data-id="element-1612">
              <div className="flex items-center gap-3" data-id="element-1613">
                <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-1614"></div>
                <span className="text-gray-900" data-id="element-1615">{t.exerciseCompleted}</span>
                <span className="text-gray-500" data-id="element-1616">EXT-UKR-000122</span>
              </div>
              <span className="text-gray-500" data-id="element-1617">4 hours ago</span>
            </div>
            <div className="flex items-center justify-between p-3 bg-gray-50 rounded text-sm" data-id="element-1618">
              <div className="flex items-center gap-3" data-id="element-1619">
                <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-1620"></div>
                <span className="text-gray-900" data-id="element-1621">{t.exerciseCompleted}</span>
                <span className="text-gray-500" data-id="element-1622">EXT-UKR-000121</span>
              </div>
              <span className="text-gray-500" data-id="element-1623">6 hours ago</span>
            </div>
          </div>
          <button className="mt-4 w-full px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors text-sm" data-id="element-1624">
            {t.viewAllLogs}
          </button>
        </div>
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4" data-id="element-1625">
          <p className="text-sm text-blue-900" data-id="element-1626">{t.autoDelivery}</p>
        </div>
      </div>
      {showAddModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-1627">
          <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 p-6" data-id="element-1628">
            <h3 className="text-lg font-semibold text-gray-900 mb-4" data-id="element-1629">
              {t.addNewChatbot}
            </h3>
            <div className="space-y-4" data-id="element-1630">
              <div data-id="element-1631">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1632">
                  {t.chatbotName}
                </label>
                <input type="text" placeholder="e.g., Dr. Bill Support Bot" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1633" />
              </div>
              <div data-id="element-1634">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1635">
                  {t.chatbotId}
                </label>
                <input type="text" placeholder="KS-BOT-XXX-XX" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1636" />
              </div>
              <div data-id="element-1637">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1638">
                  {t.orgId}
                </label>
                <input type="text" placeholder="KS-ORG-XXX-XXX" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1639" />
              </div>
            </div>
            <div className="mt-6 flex gap-3" data-id="element-1640">
              <button onClick={() => setShowAddModal(false)} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-1641">
                {t.cancel}
              </button>
              <button onClick={() => setShowAddModal(false)} className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-1642">
                {t.save}
              </button>
            </div>
          </div>
        </div>}
    </div>;
}